import { observer } from "mobx-react";
import { VBox } from "@/components-v2/Box";
import { TextQuestion } from "@/dbot/common/commonComponents";
import { MRadioButtonGroup } from "@/components-v2/RadioButton";

import { SpecialCircumstancesType } from "@/common/common";
import { languageLabels } from "@/i18n/languages";

import { useTranslation } from "@/stores/RootStoreContext";
import { LocalizedStringFieldModel, RadioFieldModel } from "@/common/commonForms";

export const SpecialCircumstances = observer(function ({
  model,
  specialCircumstancesTexts,
  question,
  addedExplanationQuestion,
  isProjectLocked,
}: {
  model: RadioFieldModel<SpecialCircumstancesType | undefined>;
  specialCircumstancesTexts: LocalizedStringFieldModel[];
  question: string;
  addedExplanationQuestion: string;
  isProjectLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <VBox>
        <div>{question}</div>
        <MRadioButtonGroup
          name={"increaseShareCapitalAgainstCashCircumstances"}
          model={model}
          disabled={isProjectLocked}
        />
      </VBox>
      {model.value === SpecialCircumstancesType.ADDED_EXPLANATION && (
        <VBox>
          {specialCircumstancesTexts.map((text) => (
            <TextQuestion
              key={text.locale}
              question={
                addedExplanationQuestion +
                (specialCircumstancesTexts.length > 1
                  ? " (" + t(languageLabels[text.locale]) + ")"
                  : "")
              }
              field={text.model}
              isLocked={isProjectLocked}
            />
          ))}
        </VBox>
      )}
    </>
  );
});
